import styles from './copy-license-access-dialog.module.scss';
import { useGetRequestNewHook, useMakeRequestHook } from '../../requestUtils';
import { useContext, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, PrimaryButton, Select, MenuItem, SnackBarContext, OrderTypesEnum } from '@frontend-workspace/react-shared-lib';
import { ILicenses } from '../../_models/licenses';
import { UseSignalRHook } from '../../signalr-context/signalr-context';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CopyLicenseAccessDialogProps {
  open: boolean,
  onClose: () => void,
  currentLicenseNumber: number,
  companyNumber: string
}
export function CopyLicenseAccessDialog(props: CopyLicenseAccessDialogProps) {
  const { t } = useTranslation();
  const makeRequest = useMakeRequestHook();
  const [copyLicenseNumber, setCopyLicenseNumber] = useState<number | string>("");
  const { data: licenses, getData }: { data: ILicenses[], getData: () => void } = useGetRequestNewHook(`companies/${props.companyNumber}/licenses/forGroup/true/onlyActive/true`, [], []);
  const { setSnackbarMessage } = useContext(SnackBarContext);

  const handleSelectCopyId = (event: any) => setCopyLicenseNumber(event.target.value);

  UseSignalRHook(getData, [OrderTypesEnum.ChangeLicenseAccess]);

  const handleCopyLicenseAccess = () => {
    makeRequest(`Licenses/${props.currentLicenseNumber}/action/copyLicenseAccess/${copyLicenseNumber}`, `PUT`)
      .then(result => {
        setSnackbarMessage({ content: t("standard.changesLicenseAccesses"), type: "info", });
      });
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth="md">
      <DialogTitle className='mb-4'>
        {t("standard.copyLicenseRights")}
      </DialogTitle>
      <DialogContent>
        <div className="d-flex flex-column mb-4">
          <div className='mb-3'>
            <Select
              fullWidth
              label={t("copyLicenseAccess.licenseYouWantToCopy")}
              name='copyLicenseNumber'
              displayEmpty
              value={copyLicenseNumber}
              onChange={handleSelectCopyId}>
              {licenses.map(license => (
                <MenuItem
                  key={license.licenseNumber}
                  value={license.licenseNumber}>
                  {`${license.licenseNumber} - ${license.productName}`}
                </MenuItem>
              ))}
            </Select>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          variant="contained"
          size='large'
          onClick={handleCopyLicenseAccess}
          className='minButtonWidth'>
          OK
        </PrimaryButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t("standard.cancel")}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default CopyLicenseAccessDialog;